module.exports = __webpack_public_path__ + "30aa9d58e26235b7a461aa3869eaee58.svg";